import {
  action,
  observable,
  makeObservable,
  runInAction,
} from "mobx";
import api from "../../../api";
import { Modal, message } from "antd";
import CommonStore from "../common_store";

class UserGroupStore {
  @observable isEnable: string = '';
  //搜索表单字段
  @observable searchForm: powerSearchData = { isEnable: true };
  @observable tableData: any = {};
  //表格加载状态
  @observable tableLoad: boolean = true;
  //控制modal展开
  @observable open: boolean = false;
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.getUserGroupPage();
    },
  };
  //查看账号列表
  @observable tableList: any = {};
  @observable modalLoading: boolean = false;

  commonStore: CommonStore;
  constructor(baseStore: CommonStore) {
    this.commonStore = baseStore;
    makeObservable(this);
  }

  setSearchForm(obj: powerSearchData) {
    runInAction(() => {
      this.searchForm = obj;
    });
  }

  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1;
    });
  }

  @action
  getUserGroupPage() {
    runInAction(() => {
      this.tableData = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchForm };
    data.size = this.pageData.size;
    data.page = this.pageData.page;

    api.userGroupApi
      .getUserGroupPage(data)
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.tableData = res.data;
            this.tableData = { ...this.tableData };
            this.tableLoad = false;
          });
          this.commonStore.getPagePermission("user_group");
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }

  @action
  deleteUserGroup(groupNo: string) {
    api.userGroupApi
      .deleteUserGroup(groupNo)
      .then((res: any) => {
        message.success("删除成功");
        this.resetPage();
        this.getUserGroupPage();
      })
      .catch((e: any) => {});
  }

  deletePower(groupNo: string) {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        centered: true,
        title: "确认删除",
        content: "您确定要删除该用户组吗？",
        okText: "确认",
        cancelText: "取消",
        onOk: () => {
          this.deleteUserGroup(groupNo);
          return resolve(true);
        },
        onCancel: () => {
          return false;
        },
      });
    });
  }

  @action
  editUserGroup(data: any) {
    api.userGroupApi
      .editUserGroup({
        groupNo: data.no,
        description: data.description,
        displayName: data.displayName,
      })
      .then((res: any) => {
        this.getUserGroupPage();
        message.success('编辑成功')
      })
      .catch((e: any) => {});
  }

  @action
  saveUserGroup(data: any) {
    api.userGroupApi
      .saveUserGroup({
        description: data.description,
        displayName: data.displayName,
        isEnable: data.isEnable,
      })
      .then((res: any) => {
        this.resetPage();
        this.getUserGroupPage();
        message.success('新增成功')
      })
      .catch((e: any) => {});
  }

  @action
  async getUserGroupList(groupNo: any) {
    runInAction(() => {
      this.modalLoading = true;
    });
    await api.userGroupApi
      .getUserGroupList(groupNo)
      .then((res: any) => {
        runInAction(() => {
          this.tableList = res
          this.modalLoading = false;
      })
      })
      .catch((e: any) => {runInAction(() => {
        this.modalLoading = false;
      });});
  }

   showModal = (groupNo: any) => {
    this.getUserGroupList(groupNo);
    runInAction(() => {
      this.open = true
  })
  };

   hideModal = () => {
    runInAction(() => {
      this.open = false
  })
  };

  @action
    setEnable(accountNo:any,isEnable:any) {
        api.userGroupApi.setEnable({accountNo:accountNo,isEnable:!isEnable}).then((res:any) => {
          message.success( isEnable ? '禁用成功' :'启用成功')
          this.getUserGroupPage()
        }).catch((e: any) => {})
    }
    @action changeIsEnable(isEnable:any,accountNo:any) {
        this.isEnable = isEnable ? '您确定要禁用该用户组吗？' : '您确定要启用该用户组吗？'
        return new Promise((resolve,reject)=>{
            Modal.confirm({
              centered:true,
              title:'确认启用/禁用',
              content:this.isEnable,
              okText: '确认',
              cancelText: '取消',
              onOk:()=>{
                this.setEnable(accountNo,isEnable)
                return resolve(true)
              },
              onCancel:()=>{
                return false
              }
            })
          })
    }
}

export default UserGroupStore;
